import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Circle, Path } from './base/Icon';
import type { BaseIconProps } from './types';

/**
 * Anonymous avatar - hat-and-glasses icon (matches lucide HatGlasses).
 * Pass color/bgColor for React Native; defaults use CSS vars (web).
 */
const AnonymousAvatar: React.FC<BaseIconProps & {
  bgColor?: string;
}> = t0 => {
  const $ = _c(21);
  const {
    size: t1,
    width,
    height,
    color,
    bgColor
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  const bg = bgColor || "rgba(var(--background-secondary-color))";
  const fg = color || "rgba(var(--primary))";
  let t2;
  if ($[0] !== bg) {
    t2 = <Circle cx="128" cy="128" r="128" fill={bg} />;
    $[0] = bg;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== fg) {
    t3 = <Path d="M56 120h144" stroke={fg} strokeWidth="10" strokeLinecap="round" />;
    t4 = <Path d="M88 120V86c0-8 8-16 40-16s40 8 40 16v34" stroke={fg} strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" fill="none" />;
    t5 = <Circle cx="104" cy="152" r="20" stroke={fg} strokeWidth="10" fill="none" />;
    t6 = <Circle cx="152" cy="152" r="20" stroke={fg} strokeWidth="10" fill="none" />;
    t7 = <Path d="M124 152c2-5 6-5 8 0" stroke={fg} strokeWidth="8" strokeLinecap="round" fill="none" />;
    t8 = <Path d="M84 152H64" stroke={fg} strokeWidth="10" strokeLinecap="round" />;
    t9 = <Path d="M172 152h20" stroke={fg} strokeWidth="10" strokeLinecap="round" />;
    $[2] = fg;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== iconHeight || $[11] !== iconWidth || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 256 256" fill="none">{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</Icon>;
    $[10] = iconHeight;
    $[11] = iconWidth;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default AnonymousAvatar;